export const MIN_BET = 1;
export const MAX_BET = 1000;
export const currencies = ["coins", "cash", "bonus"];

export function hundredths(value) {
  if (!/^\d+(?:\.\d{0,2})?$/.test(String(value).trim())) return null;
  const n = Number(value), ticks = Math.round(n * 100);
  return Number.isFinite(n) && Number.isSafeInteger(ticks) ? ticks : null;
}
export const validBet = value => { const n = hundredths(value); return n != null && n >= MIN_BET * 100 && n <= MAX_BET * 100; };
export const validTarget = value => { const n = hundredths(value); return n != null && n >= 200 && n <= 9800; };
export const chanceFor = (target, direction) => (direction === "under" ? target : 10000 - target) / 100;
export const targetForChance = (chance, direction) => Math.max(200, Math.min(9800, Math.round((direction === "under" ? chance : 100 - chance) * 100)));
export function multiplierFor(target, direction, edgePct) {
  if (edgePct == null || !Number.isFinite(edgePct)) return null;
  const count = direction === "under" ? target : 10000 - target;
  return Math.round((1 - edgePct / 100) * 100000000 / count) / 10000;
}
export function returnFor(bet, multiple) {
  const cents = hundredths(bet);
  return cents == null || multiple == null ? null : Math.round(cents * Math.round(multiple * 10000) / 10000) / 100;
}
export function validPending(value) {
  return value && /^[a-zA-Z0-9_-]{8,80}$/.test(value.request_id) && validBet(value.bet) && validTarget(value.target)
    && ["under", "over"].includes(value.direction) && currencies.includes(value.currency);
}
export function confirmedRound(data) {
  if (!validPending(data) || data.status !== "completed" || typeof data.win !== "boolean"
    || !Number.isFinite(data.roll) || data.roll < 0 || data.roll > 99.99
    || Math.abs(data.roll * 100 - Math.round(data.roll * 100)) > 1e-6
    || !Number.isFinite(data.payout) || data.payout < 0 || !Number.isFinite(data.multiplier) || data.multiplier <= 0
    || !Number.isFinite(data.chance) || data.chance < 2 || data.chance > 98
    || !Number.isFinite(data.edge_pct) || data.edge_pct < 0 || data.edge_pct > 50) {
    throw new Error("The roll response could not be confirmed.");
  }
  return data;
}
export function newRequestId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  return [...bytes].map(b => b.toString(16).padStart(2, "0")).join("");
}
